import {createSlice} from '@reduxjs/toolkit';
import {act, create} from 'react-test-renderer';

const initialState = {
   moduleIndex: null,
   moduleSlides: null,
   currentRunningSlide: 1,
};

const ModuleIndexSlice = createSlice({
   name: 'moduleIndex',
   initialState,
   reducers: {
      setModuleIndex: (state, action) => {
         state.moduleIndex = action.payload.moduleIndex;
      },
      setModuleSlides: (state, action) => {
         state.moduleSlides = action.payload.moduleSlides;
      },
      setCurrentRunningSlide: (state, action) => {
         state.currentRunningSlide = action.payload.currentRunningSlide;
      },
   },
});

export const {setModuleIndex} = ModuleIndexSlice.actions;
export const {setModuleSlides} = ModuleIndexSlice.actions;
export const {setCurrentRunningSlide} = ModuleIndexSlice.actions;

export const selectedModuleIndex = state => state.moduleIndex.moduleIndex;
export const getModuleSlides = state => state.moduleIndex.moduleSlides;
export const getCurrentRunningSlide = state =>
   state.moduleIndex.currentRunningSlide;

export default ModuleIndexSlice.reducer;
